export const MODAL_TYPE_CREATE_POST_MOBILE = 'create-post-mobile';
